import { Component } from 'react';
import service from '../../core/service';
interface IProps {
  dispatch?:any,
}

interface IState {
  loading:boolean;
  chartLoading:boolean,
  selectedItem:any;
  dashboardData:any;
  persianData:any;
  phoneData:any;
  seenData:any;
  endData:any;
}
class DashboardController extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
  }
  state: IState = {
    loading: false,
    chartLoading:false,
    selectedItem:null,
    dashboardData:[],
    persianData:[],
    phoneData:[],
    seenData:[],
    endData:[],

  };
  getDashboardData = async () => {
    this.setState({ loading: true })
    try {
      const response = await service.Dashboard.list();
      if (response) {
        this.setState({ dashboardData: response?.data?.data, loading:false });
        this.handleChartData(response?.data?.data[0])
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  handleChartData = (item:any) =>{
    this.setState({
      chartLoading:false,
      selectedItem:item,
      persianData:item?.activity.map((el:any) => el?.persian_date),
      seenData:item?.activity.map((el: { seen: number; }) => el?.seen),
      phoneData:item?.activity.map((el: { phone_data: any; }) => el?.phone_data),
      endData:item?.activity.map((el: { end_date: any; }) => el?.end_date),
    });
  }
  
}
export default DashboardController;